import { render, staticRenderFns } from "./generalPriceInfo.vue?vue&type=template&id=f8b9135c&"
import script from "./generalPriceInfo.vue?vue&type=script&lang=js&"
export * from "./generalPriceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports